namespace TabAurous.OMS {
    export interface DocumentFormatMasterForm {
        VoucherTypeId: Serenity.LookupEditor;
        StartIndex: Serenity.DecimalEditor;
        Prefix: Serenity.StringEditor;
        Separator: SeparatorEditor;
        PrefixDate: PrefixEditor;
        Suffix: Serenity.StringEditor;
        IncrementBy: Serenity.IntegerEditor;
        LastNumber: Serenity.IntegerEditor;
        PrefillwithZero: Serenity.BooleanEditor;
        Noofzeroes: Serenity.DecimalEditor;
        BranchWise: Serenity.BooleanEditor;
        CounterWise: Serenity.BooleanEditor;
        ResetMonthly: Serenity.BooleanEditor;
        ResetYearly: Serenity.BooleanEditor;
        Format: Serenity.StringEditor;
        Lock: Serenity.BooleanEditor;
    }

    export class DocumentFormatMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.DocumentFormatMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DocumentFormatMasterForm.init)  {
                DocumentFormatMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.StringEditor;
                var w3 = SeparatorEditor;
                var w4 = PrefixEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.BooleanEditor;

                Q.initFormType(DocumentFormatMasterForm, [
                    'VoucherTypeId', w0,
                    'StartIndex', w1,
                    'Prefix', w2,
                    'Separator', w3,
                    'PrefixDate', w4,
                    'Suffix', w2,
                    'IncrementBy', w5,
                    'LastNumber', w5,
                    'PrefillwithZero', w6,
                    'Noofzeroes', w1,
                    'BranchWise', w6,
                    'CounterWise', w6,
                    'ResetMonthly', w6,
                    'ResetYearly', w6,
                    'Format', w2,
                    'Lock', w6
                ]);
            }
        }
    }
}
